import { createMachine, assign, setup, createActor } from "xstate";
import { stateMachine } from "./stateMachine";

export const globalActor = createActor(stateMachine);
window.globalActor = globalActor;
// globalActor.subscribe((snapshot) => {
//   // log state changes with a bit of color
//   console.log(
//     "%cState Value: " + snapshot.value,
//     "background-color: #33aa33; color: white; font-size: 1.2em; padding:0.5em",

//     snapshot
//   );
// });
// Start the actor
globalActor.start();
